import { createApp } from 'vue'
import formatters from './plugins/formatters'
import globalHelpers from './plugins/global-helpers'
import App from './App.vue'
import router from './router'
import { setupRouterGuards } from './router/guards'
import store from './store'
import plugins from './plugins'
import i18n from './i18n'
import { openCustomerSummaryTab } from '../src/utils/dateTimeExtensions'

import dayjs, { wallClock } from './plugins/dayjs'
import eventBus from './plugins/event-bus'
import { initColorMode } from './utils/colorMode'
import './assets/css/color-mode.css'

// `$swal` Vega varsayılanlı sweetalert2 örneğidir (utils/dialog.js); onaylar `confirmDialog` ile sorulur. Eager kayıt;
// önceden `$swal` yalnız eklentiyi yan etkiyle import eden bir chunk yüklenince vardı (ör. taze yüklemede
// showERecetemWarning). Stiller ayrı CSS'ten gelir (`.all` olmayan ESM build stil enjekte etmez).
import { Dialog, confirmDialog, escapeHtml } from './utils/dialog'
import 'sweetalert2/dist/sweetalert2.min.css'

import VueDOMPurifyHTML from 'vue-dompurify-html';

// ⚠ Paketin `main` girişi (`simple-peer/index.js`) Node akış modüllerine dayanır ve
// `process.nextTick` çağırır. webpack 5 Node global'lerini artık kendiliğinden
// eklemediği için görüşme akışı açılırken "process is not defined" atıyordu; peer
// o anda yok ediliyor ve arkasından "cannot signal after peer is destroyed" geliyordu.
// Paketin hazır tarayıcı derlemesi bu bağımlılıkları kendi içinde taşır.
import SimplePeer from "simple-peer/simplepeer.min.js";
window.SimplePeer = SimplePeer;

setupRouterGuards(router)
initColorMode()

// Kök örneğin eski `created`/`methods`'u (interceptor'lar, oturum, tenant bilgisi, dil değişimi) App.vue'dadır.
const app = createApp(App)

app.config.globalProperties.$dayjs = dayjs
app.config.globalProperties.$wallClock = wallClock
app.config.globalProperties.$swal = Dialog

app.use(store)
app.use(router)
app.use(i18n)
app.use(formatters)
app.use(globalHelpers)
app.use(eventBus)
app.use(VueDOMPurifyHTML)
app.use(plugins)

// Backend'in `:onclick` satır aksiyonları ve yardımcılar kök örneğe `window.vm` ile ulaşır
// ($t, $toastr, $router, $dayjs, $store, $swal, $bus…).
const vm = app.mount('#app')
window.vm = vm;

window.openCustomerSummaryTab = openCustomerSummaryTab;

window.showERecetemWarning = function (staffId) {
  const requiredFields = [
    'DoctorBranchCode',
    'DoctorSertificateCode',
    'MedulaPassword',
    'RecetemPassword',
    'RecetemUserCode'
  ];

  confirmDialog({
    tone: 'warning',
    title: vm.$t("MissingInformationTitleForERecete"),
    text: vm.$t("MissingInformationForERecete"),
    html: `<ul class="vega-dialog__list">${requiredFields.map(field => `<li>${escapeHtml(vm.$t(field))}</li>`).join('')}</ul>`,
    confirmText: vm.$t("EditDoctor"),
    cancelText: vm.$t("Ok")
  }).then((confirmed) => {
    if (confirmed) {
      vm.$router.push({ name: 'staff.edit', params: { staffId: staffId } });
    }
  });
};
